import { hyphenateSync as hyphenateEnglish } from 'hyphen/en'
import { hyphenateSync as hyphenateSpanish } from 'hyphen/es'
import { hyphenateSync as hyphenateTelugu } from 'hyphen/te'
import i18next from 'i18next'

export function hyphenate(text: string): string {
  if (i18next.language.startsWith('en')) return hyphenateEnglish(text)
  if (i18next.language.startsWith('es')) return hyphenateSpanish(text)
  if (i18next.language.startsWith('te')) return hyphenateTelugu(text)

  return text
}
